var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('AppScrollbarContainer',{staticClass:"box__content"},[_c('div',{staticClass:"box__content__body"},[_c('h5',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.$t('Disclaimer')))]),_c('AppLegalText',{attrs:{"html-content":_vm.disclaimer}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }